import React from "react";
import { Link } from "react-router-dom";

/**
 * Grupo del menú con submenú (los roles administrativos tienen varios).
 *
 * El grupo se marca como activo y se abre solo cuando la pantalla en la que
 * estás es una de sus hijas: antes no había ninguna señal de "estás aquí" en
 * los menús con submenú.
 */
export default function SidebarGroup({ item, abierto, onToggle, pathname }) {
  const rutas = (item.subMenu || []).map((hijo) => hijo.path);
  const contieneLaActual = rutas.includes(pathname) || item.path === pathname;
  const expandido = abierto || contieneLaActual;

  return (
    <li className={`nav-item menu-items ${contieneLaActual ? "active" : ""}`}>
      <button
        type="button"
        className="nav-link sidebar-group-toggle"
        aria-expanded={expandido}
        onClick={onToggle}
      >
        <span className="menu-icon">
          <i className={item.icon}></i>
        </span>
        <span className="menu-title">{item.state}</span>
        <i
          className={`mdi sidebar-group-caret ${
            expandido ? "mdi-chevron-up" : "mdi-chevron-down"
          }`}
          aria-hidden="true"
        />
      </button>

      <div className={expandido ? "collapse show" : "collapse"}>
        <ul className="nav flex-column sub-menu">
          {(item.subMenu || []).map((hijo) => (
            <li
              className={`nav-item ${pathname === hijo.path ? "active" : ""}`}
              key={hijo.path}
            >
              <Link className="nav-link" to={hijo.path}>
                {hijo.state}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
}
